import { useState, useCallback, useEffect } from "react";
import { useConfig } from "./useConfig";
import { LotterySessionDto } from "../models/Lottery";
import { useSnackbar } from "notistack";

export const usePrizes = (sessionId: string) => {
  const [lotteryPrizes, setLotteryPrizes] = useState<LotterySessionDto | null>(
    null
  );
  const [loading, setLoading] = useState(false);
  const { config } = useConfig();
  const { enqueueSnackbar } = useSnackbar();

  const fetchData = useCallback(async () => {
    if (!sessionId) return;
    setLoading(true);
    try {
      const res = await fetch(`${config.apiUrl}/lottery/prizes/${sessionId}`, {
        method: "GET",
      });

      if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

      const json = (await res.json()) as any;
      setLotteryPrizes(json);
    } catch (err) {
      console.log(err);
      enqueueSnackbar(`${err}`, {
        variant: "error",
        autoHideDuration: 4000,
      });
    } finally {
      setLoading(false);
    }
  }, [config.apiUrl, enqueueSnackbar, sessionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { lotteryPrizes, loading, refetch: fetchData };
};
